<template>
  <v-tooltip top :color="schema.tooltipColorClass" :disabled="!schema.tooltip" :key="generateId(schema.model)">
    <template v-slot:activator="{ on, attrs }">
      <div
        :data-has-tooltip="schema.attributes.disabled ? schema.tooltipDisabled : schema.tooltip ? 'true' : 'false'"
        :data-tooltip="schema.attributes.disabled ? schema.tooltipDisabled : schema.tooltip"
        v-on="on"
        v-bind="attrs"
        @contextmenu="selectComponentDEV($event, schema.model)"
        :class="[getSelectedDEV && 'dev-selected-component']"
      >
        <v-switch
          :name="schema.model"
          :id="generateId(schema.model)"
          :rules="rules"
          :value="schema.value"
          v-bind="schema.attributes"
          :disabled="schema.readonly"
          v-model="value"
          @blur="onBlur"
          @change="onChange"
          @focus="onFocus"
          @input="onInput"
        >
          <template v-slot:label>
            <span v-bind="schema.attributes.attributesLabel">
              {{ labelText }}
            </span>
            <span v-if="schema.rules.includes('required')" class="red--text">*</span>
          </template>
        </v-switch>
      </div>
    </template>
    <span>{{ schema.attributes.disabled ? schema.tooltipDisabled : schema.tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import * as HANDLERS from '@/helpers/types/handlers';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  data: () => ({
    required: v => (v === undefined || v === null ? `Este campo é obrigatório` : true)
  }),

  computed: {
    labelText() {
      if(!this.schema.attributes.label)
        return '';

      if(/{(.*\w)}/.test(this.schema.attributes.label)){
        return this.model[this.schema.attributes.label.match(/{(.*\w)}/).pop()] ?? this.schema.attributes.label
      }

      return this.model[`${this.schema.model}_label`] ?? this.schema.attributes.label;
    }
  },

  events: {
    [HANDLERS.ENABLED_FIELD]: 'active'
  },

  methods: {
    active: function (field) {
      if (this.schema.model === field) this.schema.readonly = false;
    },

    onChange: async function () {
      this.changeEvents();
    },
  }
};
</script>
